import DeviationMediaService from '../../utils/DeviationMediaService';
import { DeviationTypes } from '../../types/deviation';
export var FIRST_IMAGE_FEATURE = 'FIRST_IMAGE_FEATURE';
export var firstImageFeature = function (editorState, raw) {
    for (var key in raw.entityMap) {
        var entity = raw.entityMap[key];
        switch (entity.type) {
            case 'wix-draft-plugin-gallery':
                if (entity.data && entity.data.data) {
                    var first = entity.data.data[0];
                    if (first && mightBeADeviation(first)) {
                        return makeFeature(first);
                    }
                }
                break;
            case 'wix-draft-plugin-image':
                if (entity.data &&
                    entity.data.data &&
                    mightBeADeviation(entity.data.data)) {
                    return makeFeature(entity.data.data);
                }
                break;
            default:
        }
    }
    return {
        type: FIRST_IMAGE_FEATURE,
        data: {},
    };
};
function makeFeature(deviation) {
    return {
        type: FIRST_IMAGE_FEATURE,
        data: {
            deviation: deviation,
        },
    };
}
function mightBeADeviation(obj) {
    return DeviationMediaService.getDeviationType(obj) === DeviationTypes.IMAGE;
}
//# sourceMappingURL=firstImage.js.map